import '../vendor';

import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { mixinTranslation } from './translation';

angular.module('ts-awaiter', []).run(['$window', '$q', ($window: ng.IWindowService, $q: ng.IQService) => {
    $window.Promise = $q;
}]);

const ngModule = angular.module('app.common', ['ts-awaiter', 'pascalprecht.translate']);
mixinTranslation(ngModule, ['en', 'no'], 'common');

const tsContext = require.context('.', true, /\.ts$/);
tsContext.keys().forEach(tsContext);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/index.ts